import React from "react";

// Reusable pill chip for Category / Sub Category values. Matches the
// existing category-color styling already used elsewhere in the app
// (pill shape, 12px/600-weight text, per-category background color from
// bg_color, falling back to the app's light-teal tint when unset).
const DEFAULT_BG_COLOR = "#d7f0f0";
const DEFAULT_TEXT_COLOR = "rgba(42, 42, 42, 0.77)";

const CategoryChip = ({ label, color, className = "", style = {} }) => {
  if (!label) return null;

  return (
    <span
      className={`inline-block rounded-full px-3 py-1 text-center text-xs font-semibold tracking-wide ${className}`}
      style={{
        backgroundColor: color || DEFAULT_BG_COLOR,
        color: DEFAULT_TEXT_COLOR,
        letterSpacing: "0.03em",
        ...style,
      }}
    >
      {label}
    </span>
  );
};

export default CategoryChip;
